import { render, staticRenderFns } from "./player-video.vue?vue&type=template&id=ed32de68"
import script from "./player-video.vue?vue&type=script&lang=js"
export * from "./player-video.vue?vue&type=script&lang=js"
import style0 from "./player-video.vue?vue&type=style&index=0&id=ed32de68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports